<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-input-number [nzFormatter]="formatterAmount" nzMin="0"
  [name]="sectionTagName+'.' +field.FieldName"
    [(ngModel)]="recordProperty.ValueAsObject" [ngModelOptions]="{ updateOn: 'blur'}"
    (ngModelChange)="valueChanged()"
    [class]="parentClass"
    [nzDisabled]="recordProperty.ReadOnly" [nzParser]="numberParser">
  </nz-input-number>
</nz-form-control>
